import { UpdateCompanyPayload } from "@app/store/api/ApiService";

import DetailsFormValues from "../Details/DetailsFormValues";

const getCompanyPayloadFromFormData = (
  formData: DetailsFormValues
): Partial<UpdateCompanyPayload> => ({
  annualRevenue: formData.annualRevenue ?? null,
  cadenceInterval: formData.cadenceInterval,
  color: formData.color,
  crmActivityTypeId: formData.crmActivityTypeId,
  email: formData.email,
  name: formData.name,
  numEmployees: formData.numEmployees ?? null,
  parentAccount: formData.parentCompanyId
    ? {
        id: formData.parentCompanyId,
      }
    : null,
  phone: formData.phone,
  user: { id: formData.user },
  website: formData.website,
});

export default getCompanyPayloadFromFormData;
